var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellChangeHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0625 15.25C3.0625 15.7141 3.24687 16.1592 3.57506 16.4874C3.90325 16.8156 4.34837 17 4.8125 17C5.27663 17 5.72175 16.8156 6.04994 16.4874C6.37813 16.1592 6.5625 15.7141 6.5625 15.25C6.5625 14.7859 6.37813 14.3408 6.04994 14.0126C5.72175 13.6844 5.27663 13.5 4.8125 13.5C4.34837 13.5 3.90325 13.6844 3.57506 14.0126C3.24687 14.3408 3.0625 14.7859 3.0625 15.25Z",
    stroke: "#4B68CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 15.25C13.5625 15.7141 13.7469 16.1592 14.0751 16.4874C14.4033 16.8156 14.8484 17 15.3125 17C15.7766 17 16.2217 16.8156 16.5499 16.4874C16.8781 16.1592 17.0625 15.7141 17.0625 15.25C17.0625 14.7859 16.8781 14.3408 16.5499 14.0126C16.2217 13.6844 15.7766 13.5 15.3125 13.5C14.8484 13.5 14.4033 13.6844 14.0751 14.0126C13.7469 14.3408 13.5625 14.7859 13.5625 15.25Z",
    stroke: "#4B68CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 10V8.25C4.8125 6.85761 5.36562 5.52226 6.35019 4.53769C7.33476 3.55312 8.67011 3 10.0625 3C11.4549 3 12.7902 3.55312 13.7748 4.53769C14.7594 5.52226 15.3125 6.85761 15.3125 8.25V10",
    stroke: "#4B68CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 8.25L15.3125 10.875L17.9375 8.25",
    stroke: "#4B68CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellChangeHover);
export default __webpack_public_path__ + "static/media/icn_table_cell_change_hover.54b384db06e20bfb58ab9c95cb69ebe8.svg";
export { ForwardRef as ReactComponent };